import Logo from "shared/Logo/Logo";
import SocialsList1 from "shared/SocialsList1/SocialsList1";
import { CustomLink } from "data/types";
import React from "react";
import ncNanoId from "utils/ncNanoId";
import { useHistory, useLocation } from "react-router";

export interface WidgetFooterMenu {
  id: string;
  title: string;
  menus: CustomLink[];
}
const Footer: React.FC = () => {
  const history = useHistory();

  const ToLegal = (data: any) => {
    if (data == 'tc') {
      history.replace('/term-and-condition');
    } else {
      history.replace('/privacy-policy');

    }
  }
  return (
    <div id="footer" className="nc-Footer relative py-12 lg:py-32 border-t border-neutral-200 dark:border-neutral-700">
      <div className="container sm:flex md:grid md:grid-flow-col md:grid-cols-4 md:grid-rows-1 ">
        <div className=" space-y-1 mb-8 md:-mb-0 md:space-y-2 ">
          <Logo className="h-6 sm:mb-2" />
          <SocialsList1 className="flex items-center space-x-3 lg:space-x-0 lg:flex-col lg:space-y-2.5 lg:items-start" />
        </div>
        <div className="md:space-y-2 md:col-span-2 space-y-1 mb-8 md:mb-0 md:mx-auto ">
          <div className="md:h-8 mb-4 md:mb-0">
            <h4 className="font-semibold text-neutral-600 dark:text-neutral-200  ">
              Guidesantai GmbH
            </h4>
          </div>

          <p>Röschenzerstrasse 24, 4053 Basel Switzerland</p>
          <p>Phone: +4176 303 00 56</p>
          <p>E-Mail: info@guidesantai.com</p>
        </div>
        <div className="md:space-y-2 mb-8 md:mb-0 ">
          <div className="md:h-8 mb-4 md:mb-0">
            <h4 className="font-semibold text-neutral-700 dark:text-neutral-200 ">
              Helpful Links
            </h4>
          </div>
          <ul className="md:mt-5 md:space-y-4 mt-0 space-y-1">
            <li key={ncNanoId()} style={{ marginTop: 5 }}>
              <a href="mailto:info@guidesantai.com" className="text-neutral-6000 dark:text-neutral-300 hover:text-black dark:hover:text-white" >
                Contact
              </a>
            </li>
            <li key={ncNanoId()} style={{ marginTop: 5 }}>
              <a className="text-neutral-6000 dark:text-neutral-300 hover:text-black dark:hover:text-white cursor-pointer" onClick={() => ToLegal('tc')}  >
                Term and Condition
              </a>
            </li>
            <li key={ncNanoId()} style={{ marginTop: 5 }}>
              <a className="text-neutral-6000 dark:text-neutral-300 hover:text-black dark:hover:text-white cursor-pointer" onClick={() => ToLegal('pp')}  >
                Privacy & Policy
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div >
  );
};

export default Footer;
